var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareMessenger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "-2 -2 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 14.816c0 4.667 2.328 8.818 5.961 11.531V32l5.45-2.994C21.07 31.718 32 25.222 32 14.816 32 6.63 24.836 0 15.996 0 7.486 0 0 6.387 0 14.816m14.313-4.144 4.176 4.339 7.84-4.34-8.744 9.281-4.074-4.347-7.943 4.347z",
  clipRule: "evenodd"
})));
export default SvgShareMessenger;